import { createSlice } from "@reduxjs/toolkit";
import { AppSettings } from "utils/types/app";

export type DataState = {
  readonly info: AppSettings | null;
  readonly isLoading: boolean;
};

const INITIAL_STATE: DataState = { info: null, isLoading: false };
const siteDataSlice = createSlice({
  name: "data",
  initialState: INITIAL_STATE,
  reducers: {
    setDataInfo(state, action) {
      state.info = action.payload;
    },
  },
});

export const { setDataInfo } = siteDataSlice.actions;
export default siteDataSlice;
